import input from '@/components/input'

/**
 * @module
 * @name InputText
 * @extends Input
 */
export default {
  name: 'InputText',
  extends: input,
  data: function () {
    return {
      inputHasFocus: false
    }
  },

  /**
   * @property {String} icon VueSVGicon
   * @property {String} placeholder Placeholder to show while input is empty.
   * @property {String} type Text input could also be of type number, password.
   * @property {Boolean} removeIcon If true, shows X to delete input content.
   */
  props: {
    type: {
      type: String,
      required: false,
      validator: v => ['textarea'].indexOf(v) !== -1,
      default: 'text'
    },
    placeholderTxt: String
  }

}
